import { signOut } from "firebase/auth";
import { getFirebaseAuth } from "../firebase";
import { removeItemFromLocalStorage } from "../utils/localStorage";
import { TOKEN } from "../constants/const";
import { resetCommunityPusher } from "../pusherClient";

export const logout = async () => {
    if (typeof window === "undefined") return;
    const auth = getFirebaseAuth();
    try {
        removeItemFromLocalStorage(TOKEN);
        resetCommunityPusher();
        await signOut(auth);
    } catch (error) {
        console.error("Error signing out:", error);
    }
};
